export default {
  component: (isSpecial: boolean, isActive: boolean) => {
    const standardBackground = isSpecial ? '#272727' : '#0d0d14';
    return {
      padding: '5px 15px',
      background: isActive ? '#2d313b' : standardBackground,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      '&:hover': {
        background: '#2d313b'
      }
    };
  },
  componentIcon: {
    paddingTop: '6px'
  }
};